import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminClient from "../../../components/admin/client/account/AdminClient";

const AdminClientInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //클라이언트 식별자가 없는 경우
    if (!id) {
        return <div>Invalid project ID</div>;
    }

    return (
        <AdminLayout>
            {/*클라이언트 상세 페이지 버튼*/}
            <AdminClient clientId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminClientInfoPage;